import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, Observer } from 'rxjs';
import { ConfirmationService } from 'primeng';

export interface CanComponentDeactivate {
  confirm(): boolean | Observable<boolean>;
}

@Injectable()
export class PendingChangesGuard implements CanDeactivate<CanComponentDeactivate> {
  constructor(private confirmationService: ConfirmationService) {}

  canDeactivate(
    component: CanComponentDeactivate,
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | Observable<boolean> {
    if (!component.confirm()) {
      return new Observable((observer: Observer<boolean>) => {
        this.confirmationService.confirm({
          message: 'You may have unsaved changes. Are you sure you want to leave this page?',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'Leave anyway',
          rejectLabel: 'Stay on page',
          accept: () => {
            observer.next(true);
            observer.complete();
          },
          reject: () => {
            observer.next(false);
            observer.complete();
          },
        });
      });
    }

    return true;
  }
}
